import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, {
    staticClass: "template-metainfo-form"
  }, [_vm.template ? _c(VCol, {
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "input_twin_title",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.enterTwinTitle'),
      "color": _vm.color,
      "rules": [v => !!v && v.trim() !== '' || _vm.$i18n_t('Common.fieldRequired')],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "twinObjectTitle",
      "clearable": "",
      "required": "",
      "disabled": _vm.isProductiveVersion || _vm.readonly
    },
    model: {
      value: _vm.template.title,
      callback: function ($$v) {
        _vm.$set(_vm.template, "title", $$v);
      },
      expression: "template.title"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.titleDigitalTwinHint')))])], 1), _c(VCol, {
    attrs: {
      "cols": "6",
      "lg": "6",
      "sm": "6",
      "md": "6"
    }
  }, [_c('core-account-selector', {
    attrs: {
      "disabled": true
    },
    model: {
      value: _vm.template.tenantId,
      callback: function ($$v) {
        _vm.$set(_vm.template, "tenantId", $$v);
      },
      expression: "template.tenantId"
    }
  })], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('core-dtwin-finder', {
    attrs: {
      "objectFilter": _vm.parentSelectorFilter,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "tenantId": _vm.template.tenantId,
      "sameTenant": "",
      "required": "",
      "hideDetails": "",
      "disabled": _vm.isProductiveVersion || _vm.readonly
    },
    model: {
      value: _vm.template.parentId,
      callback: function ($$v) {
        _vm.$set(_vm.template, "parentId", $$v);
      },
      expression: "template.parentId"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.parentDigitalTwinHint')))])], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "value": _vm.scopeDetailledName,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.scope'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "disabled": "",
      "data-cy": "template_scope"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.scopeText')))])], 1)], 1)], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VRow, [_c(VCol, [_vm.markdownEdit ? _c(VCard, {
    staticClass: "elevation-0 v-card-text-area mdbox",
    attrs: {
      "outlined": ""
    }
  }, [_c(VCardText, [_c('markdown-it-vue-light', {
    attrs: {
      "readonly": _vm.readonly,
      "content": _vm.template.description || ''
    }
  })], 1)], 1) : _c(VCard, [_vm.template ? _c(VTextarea, {
    attrs: {
      "data-cy": "input_twin_description",
      "label": _vm.$i18n_t('Common.description'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rows": "7",
      "hide-details": "auto",
      "clearable": "",
      "disabled": _vm.isProductiveVersion || _vm.readonly
    },
    model: {
      value: _vm.template.description,
      callback: function ($$v) {
        _vm.$set(_vm.template, "description", $$v);
      },
      expression: "template.description"
    }
  }) : _vm._e()], 1)], 1)], 1), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "label": _vm.$i18n_t('Common.mdeditor'),
      "color": _vm.color,
      "disabled": _vm.isProductiveVersion || _vm.readonly
    },
    model: {
      value: _vm.markdownEdit,
      callback: function ($$v) {
        _vm.markdownEdit = $$v;
      },
      expression: "markdownEdit"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };